export const WATCH_EDIT_MODE = {
  RUNTIME: 'runtime',
  EDIT: 'edit'
}

export const WATCH_EDIT_MODE_KEY = 'watchEditableMode'

// Parent key for the editable component selected in edit mode.
const selectedState = { key: '' }
export const getSelectedEditableParentKey = () => selectedState.key
export const setSelectedEditableParentKey = (key) => { selectedState.key = key }

export const getWatchEditMode = ({ allAssets, dialType }) => {
  if (!allAssets) return WATCH_EDIT_MODE.RUNTIME

  return allAssets.getIn([dialType, WATCH_EDIT_MODE_KEY]) || WATCH_EDIT_MODE.RUNTIME
}

export const isWatchEditMode = ({ allAssets, dialType }) => getWatchEditMode({ allAssets, dialType }) === WATCH_EDIT_MODE.EDIT

const getEnabledComponentKeys = ({ menu, parentKey }) => {
  const menuItem = menu?.find?.((item) => item.get('key') === parentKey)
  return menuItem?.get?.('children')?.filter?.((item) => item.get('checked') === true)?.map?.((item) => item.get('key')) || null
}

const getFirstEnabledComponentKey = ({ menu, parentKey, componentData }) => {
  const enabledComponentKeys = getEnabledComponentKeys({ menu, parentKey })
  const checkedChildKey = enabledComponentKeys?.first?.()

  if (checkedChildKey) {
    return checkedChildKey
  }

  const props = componentData?.get?.('props')
  const firstPropKey = props?.keySeq?.()?.first?.()
  return firstPropKey || ''
}

export const getEditableDisplayComponentKey = ({ allAssets, dialType, path, menu, parentKey, componentData }) => {
  if (!allAssets) return ''

  const enabledComponentKeys = getEnabledComponentKeys({ menu, parentKey })
  const value = allAssets.getIn([dialType, ...path, 'value'])
  const defaultShow = allAssets.getIn([dialType, ...path, 'defaultShow'])

  if (enabledComponentKeys?.size) {
    if (enabledComponentKeys.includes(value)) return value
    if (enabledComponentKeys.includes(defaultShow)) return defaultShow
    return enabledComponentKeys.first()
  }

  return (
    value ||
    defaultShow ||
    getFirstEnabledComponentKey({ menu, parentKey, componentData }) ||
    ''
  )
}
